import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { IonicModule } from "@ionic/angular";
import { BreadCrumbModule } from "../breadcrumb/breadcrumb.module";
import { PermissionsModule } from "../permissions-module/permissions-module";
import { ViewPdfModalModule } from "../view-pdf-modal/view-pdf-modal.module";
import { PageHeaderComponent } from "./page-header.component";

@NgModule({
  declarations: [PageHeaderComponent],
  imports: [
    CommonModule,
    IonicModule,
    RouterModule,
    BreadCrumbModule,
    PermissionsModule,
    ViewPdfModalModule,
  ],
  exports: [PageHeaderComponent],
})
export class PageHeaderModule {}
